export default __webpack_public_path__ + "73860324d828817be23600d07a5bdcb2.woff";